import React from "react";

import { Line } from "react-chartjs-2";

import ChartBase from "./ChartBase";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
  },
};

export const data = {
  labels: ["January", "February", "March", "April"],
  datasets: [
    {
      label: "Dataset 1",
      data: [19, 22, 66, 22],
      borderColor: "rgb(255, 99, 132)",
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: "Dataset 2",
      data: [60, 79, 6, 92],
      borderColor: "rgb(53, 162, 235)",
      backgroundColor: "rgba(53, 162, 235, 0.5)",
    },
  ],
};
const LineChart = (props) => {
  return (
    <div className={` ${props.customCss} `}>
      <ChartBase
        chartName="Inventory Distribution"
        subheading="Report Center"
        seeDetail={false}
        openComparePopUpToggle={props.openComparePopUpToggle}
      >
        <Line data={data} options={options} />
      </ChartBase>
    </div>
  );
};
export default LineChart;
